// @ts-nocheck
import { defineStore } from 'pinia';
export default defineStore('user-answer-status', {
    state: () => ({
        currentQuestionId: null,
        selectedAnswerType: null,
    }),
    actions: {
        changeSelectedAnswer(value) {
            this.selectedAnswerType = value;
        },
        changeCurrentQuestionId(value) {
            this.currentQuestionId = value;
        },
        initializeState() {
            this.$reset();
        },
    },
});
